// Returns the angle of a line in degrees.
export function angle(line){
  return Math.atan2(line[1][1] - line[0][1], line[1][0] - line[0][0]) * 180 / Math.PI;
}

// Returns the midpoint of a line.
export function midpoint(line){
  return [(line[0][0] + line[1][0]) / 2, (line[0][1] + line[1][1]) / 2];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-regression@1.3.5@d3-regression/src/utils/geometry.js
// module id = null
// module chunks = 